/*eslint-disable */
import {mapGetters} from 'vuex';
import {
  bus
} from '@/main';
export default {
  name: 'briefcaseStorageBreakdown',
  components: {},
  props: [],
  data () {
    return {
      getStorageInfoData:null,
      getStorageInfoResults:[],
      selfUserInfo:null
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserInfoFun(){
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    getStorageInfoFun(){
      return this.$store.getters.breakdownStorageGetters
    }
  },
  mounted () {
  },
  created(){
   this.$store.dispatch('getbriefcaseStorageBreakdownAction')
  },
  methods: {
    briefcaseStorageBreakdownFun(){
      bus.$emit('normalBriefcaseViewStateBus', true)
      bus.$emit('briefcaseStorageBreakdownStateBus', false)
    },
    trimDecimalVal(num){
      if(num != undefined){
        if(num === 0){
          return 0;
        }else{
          return num.toFixed(2).replace(/(\.0+|0+)$/, '');
        }
      }
    }
  },
  watch:{
    getStorageInfoFun(newVal, oldVal){
      this.getStorageInfoData = newVal
      this.getStorageInfoResults = this.getStorageInfoData.data
    },
    getSelfUserInfoFun(){
      return this.$store.getters.acUserDetailsStateGetters
    },
  }
}


